import React from "react"
import { useSelector } from "react-redux"
import { useTranslation } from "react-i18next"
import PropTypes from "prop-types"
// Component
import Button from "../Button/Button"
// Data
import { heroImageItems as data } from "../../data"
// Styles
import {
   Container,
   Wrapper,
   Title,
   Description,
   StyledLink,
} from "./HeroImage.styles"

const HeroImage = ({ imageHeight, imageNumber }) => {
   const { t } = useTranslation()
   const language = useSelector((state) => state.environment.language)

   const item = {
      id: data[imageNumber].id,
      title:
         language === "fr"
            ? data[imageNumber].titleFr
            : data[imageNumber].titleEn,
      img: data[imageNumber].img,
      bg: data[imageNumber].bg,
      desc:
         language === "fr"
            ? data[imageNumber].descFr
            : data[imageNumber].descEn,
      button: data[imageNumber].button,
      buttonLink: data[imageNumber].buttonLink,
   }

   return (
      <Container img={item.img} imageHeight={imageHeight}>
         <Wrapper>
            <Title>{item.title}</Title>
            <Description>{item.desc}</Description>
            {item.button ? (
               <StyledLink to={item.buttonLink}>
                  <Button text={t("heroImage.button.b1")} width={25} />
               </StyledLink>
            ) : (
               <></>
            )}
         </Wrapper>
      </Container>
   )
}

HeroImage.propTypes = {
   imageHeight: PropTypes.string,
   imageNumber: PropTypes.number,
}

export default HeroImage
